var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-widget',{style:(_vm.heightStyles),attrs:{"title":"Activity","items":_vm.userActivityTabNames(),"scrollable":""},on:{"tabChanged":_vm.onTabChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var current = ref.current;
return [_c(_vm.getActivityTabComponent(_vm.userActivityTabNames()[current]),{tag:"component"})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }